<div class="iti-flag" [ngClass]="countryClass"></div>
